<!--
 * @Autor: zhiying Qin
 * @Date: 2025-04-09 23:32:47
 * @LastEditTime: 2025-09-28 21:47:33
-->
<template>
    <div class="listPost">
      <div class="ui-content" style="margin-top: 16px">
        <section class="record-list">
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <van-list
              v-model="loading"
              :finished="finished"
              :immediate-check="false"
              finished-text="没有更多了"
              @load="onLoad"
              :offset="20"
              error-text="请求失败，点击重新加载"
            >
              <li v-for="item in list" :key="item.index" class="li-items">
                <p :style="{fontSize: '16px', position: 'relative', padding: '0px 10px'}"
                >
                  {{ item.employerName }}
                </p>
                <div style="margin: 10px">
                  <div class="title">
                    {{ item.positionName }}
                  </div>
                  <div class="items-content">
                    <p class="tag">
                      <van-tag type="primary" style="margin-right: 10px">{{
                        item.educationalBackground
                      }}</van-tag>
                      <van-tag type="primary" style="margin-right: 10px">{{
                        item.degree
                      }}</van-tag>
                      <van-tag type="primary" style="margin-right: 10px">{{
                        item.sourceCategory
                      }}</van-tag>
                    </p>
  
                    <ol>
                      <li>
                        <span class="label">岗位代码：</span>
                        <span class="label-content" style="line-height: 16px;">{{ item.positionCode }}</span>
                      </li>
                      <li>
                        <span class="label">岗位类别：</span>
                        <span class="label-content">{{ item.positionCategory }}</span>
                      </li>
                      <li>
                        <span class="label">招考数量：</span>
                        <span class="label-content">{{ item.candidatesNum }}</span>
                      </li>
                      <li>
                        <span class="label">入围比例：</span>
                        <span class="label-content">{{ item.shortlistedProportion }}</span>
                      </li>
                      <li>
                        <span class="label">岗位工作内容：</span>
                        <span class="label-content">{{ item.positionContent }}</span>
                      </li>
                      <li>
                        <span class="label">所学专业：</span>
                        <span class="label-content">{{ item.major }}</span>
                      </li>
                      <li>
                        <span class="label">考试专业科目：</span>
                        <span class="label-content">{{ item.examinationSubject }}</span>
                      </li>
                      <li>
                        <span class="label">专业技术资格/高校毕业生：</span>
                        <span class="label-content">{{ item.technicalUniversities }}</span>
                      </li>
                      <li>
                        <span class="label">专业技术资格/社会人才：</span>
                        <span class="label-content">{{ item.technicalSociety }}</span>
                      </li>
                      <li>
                        <span class="label">职业资格/高校毕业生：</span>
                        <span class="label-content">{{ item.professionalUniversities }}</span>
                      </li>
                      <li>
                        <span class="label">职业资格/社会人才：</span>
                        <span class="label-content">{{ item.professionalSociety }}</span>
                      </li>
                      <li>
                        <span class="label">其他条件：</span>
                        <span class="label-content">{{ item.otherConditions }}</span>
                      </li>
                      <li>
                        <span class="label">工作地点：</span>
                        <span class="label-content">{{ item.workPlace }}</span>
                      </li>
                      <li>
                        <span class="label">咨询电话：</span>
                        <span class="label-content">{{ item.enquiryTelephone }}</span>
                      </li>
                      <li>
                        <span class="label">数据年份：</span>
                        <span class="label-content">{{ item.dataYear }}</span>
                      </li>
                    </ol>
                  </div>
                  <div class="items-content-footer">
                    <van-icon
                      :name="item.isCollect ? 'star' : 'star-o'"
                      size="20"
                      :color="item.isCollect ? 'orange' : ''"
                      @click="postCollect(item)"
                    />
  
                    <van-button
                      type="info"
                      size="small"
                      round
                      @click="postCollect(item)"
                      >{{item.isCollect ? '取消收藏' : '收藏'}}</van-button
                    >
                  </div>
                </div>
              </li>
  
              <!-- 加载状态提示 -->
              <template #loading>
                <div class="loading-text">加载中...</div>
              </template>
            </van-list>
          </van-pull-refresh>
        </section>
      </div>
    </div>
  </template>
  
  <script>
  import Vue from 'vue'
  import { postList, armyPostGetPostFilter, armyPostCollect, myCollectList, applicationApply, armyPostList } from '@/api/xicaiquan'
  import { Tag, List, PullRefresh, Button, Toast, Dialog } from 'vant'
  Vue.use(Tag)
  Vue.use(List)
  Vue.use(PullRefresh)
  Vue.use(Button)
  Vue.use(Dialog)
  export default {
    name: 'listPost',
    props: {
      type: String,
      form: Object
    },
    data () {
      return {
        list: [], // 列表数据
        loading: false, // 列表加载状态
        finished: false, // 列表是否加载完成
        isLoading: false, // 下拉刷新状态
        page: 1, // 当前页码
        pageSize: 10, // 每页条数
        queryParams: {
            current: 1,
            size: 20,
            phone: sessionStorage.getItem("service_phone"),
            isCollect: false,
            otherNotInclude: [],
            workPlace: [],
            otherInclude: [],
            otherInclude: [],
            sourceCategory: "",
            educationalBackground: ""

        },
      }
    },
    created () {
      // if (this.type == "precisePost") {
      //   this.getPostFilter();
      // }
      // this.list = [];
      document.documentElement.scrollTop=0
      window.pageYOffset=0
      document.body.scrollTop=0
  
    
      this.loadData()
    },
    components: {
    },
    watch: {},
    methods: {
      async getData () {

        if (!sessionStorage.getItem("service_phone")) {
          return []
        }

        if (this.type == 'precisePost') {
          const res = await armyPostGetPostFilter({phone: sessionStorage.getItem("service_phone")})
          if (res.code == 200) {
            Object.assign(this.queryParams, res.data)
  
            const res1 = await armyPostList(this.queryParams)
            return (res1.data && res1.data.records) || []

          } else {
            return []
          }
          
          // console.log(res1);
        }
  
        if (this.type == 'intelligencePost') {
          Object.assign(this.queryParams, this.form)
          console.log("form", this.form)
  
          const res1 = await armyPostList(this.queryParams)
          console.log("res1", res1)
          // console.log(res1);
          return (res1.data && res1.data.records) || []
        }
  
        if (this.type == "myCollect") {
          const res1 = await armyPostList({...this.queryParams, isCollect: true})
          // console.log(res1);
          return (res1.data && res1.data.records) || []
        }
  
        // console.log(this.queryParams, "sdfdsfsd");
      },
  
      // 加载数据
      async loadData () {
        try {
          this.loading = true;
          const data = await this.getData()
          console.log('data111', data)
  
          if (data) {
             // 如果是第一页，直接替换数据
            if (this.queryParams.current === 1) {
              this.list = data
            } else {
              // 否则追加数据
              this.list = [...this.list, ...data]
            }
  
            // 判断是否还有更多数据
            if (data.length < this.queryParams.size) {
              this.finished = true
            }
          }
         
        } catch (error) {
          console.error('加载数据失败:', error)
        } finally {
          this.loading = false
          this.isLoading = false
        }
      },
  
      // 列表滚动到底部时触发
      onLoad () {
        if (this.finished) return
        console.log("执行的。。。。。")
        this.queryParams.current++
        this.loadData()
      },
  
      // 下拉刷新触发
      onRefresh () {
        this.queryParams.current = 1
        this.finished = false
        this.loading = true
        this.loadData()
      },
  
      // 收藏
      async postCollect (item) {
        const res = await armyPostCollect({ phone: sessionStorage.getItem("service_phone"), isCollect: !item.isCollect, positionCode: item.positionCode })
        if (res.code == 200) {
          if (item.isCollect) {
            Toast('已取消收藏')
          } else {
            Toast('收藏成功')
          }
        }
  
        item.isCollect = !item.isCollect
      },
    //   copyUrl (row) {
    //     Dialog.confirm({
    //       title: '温馨提示',
    //       message: '确定复制链接并投递吗？',
    //     })
    //     .then(() => {
    //       // on confirm
  
    //       // 创建一个临时的文本输入框
    //       const tempInput = document.createElement('input')
    //       // 将需要复制的内容赋值给输入框
    //       tempInput.value = row.sendLink
    //       // 将输入框添加到文档中
    //       document.body.appendChild(tempInput)
    //       // 选中输入框的内容
    //       tempInput.select()
    //       // 执行复制命令
    //       document.execCommand('copy')
    //       // 从文档中移除临时输入框
    //       document.body.removeChild(tempInput)
  
    //       Toast('复制成功')
  
    //       applicationApply({id: row.id}).then(res1 => {
  
    //       })
  
    //     })
    //     .catch(() => {
    //       // on cancel
    //     });
        
    //   }
    }
  }
  </script>
  <style scoped lang="scss">
  .listPost {
    width: 100%;
    .ui-content {
      width: 95%;
      margin: 0px auto;
      .li-items {
        border-radius: 10px;
        background: #fff;
        margin-bottom: 20px;
        p {
          border-bottom: 1px solid #ddd;
          line-height: 40px;
          padding: 10px 0px;
        }
  
        .title {
          background: #e0edfe;
          border-radius: 10px 10px 0px 0px;
          line-height: 40px;
          font-size: 16px;
          text-indent: 6px;
          margin-top: 20px;
          position: relative;
          overflow: hidden;
          padding-right: 10px;
          text-overflow: ellipsis;
          white-space: nowrap;
  
          .ribbon {
            width: 80px;
            height: 40px;
            background: orange;
            position: absolute;
            top: 0;
            right: -25px;
            transform: rotate(34deg);
            transform-origin: top right;
            box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
          }
  
          .ribbon-text {
            position: absolute;
            top: 12px;
            right: 12px;
            color: white;
            font-weight: bold;
            font-size: 12px;
            transform: rotate(0deg);
            transform-origin: right center;
            font-family: 'Arial', sans-serif;
          }
  
          /* 可选：让角标右上角带圆角 */
          .ribbon::before {
            content: '';
            position: absolute;
            top: 0;
            right: 0;
            width: 12px;
            height: 12px;
            background: white;
            border-top-left-radius: 12px;
          }
        }
  
        .items-content {
          background: #fafbff;
          padding: 6px;
          .tag {
            display: flex;
          }
  
          ol {
            margin: 20px 0px;
            li {
              display: flex;
              margin: 20px 0px;
              .label {
                color: #999;
                white-space: nowrap;
              }
              .label-content {
              }
            }
          }
        }
  
        .items-content-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-top: 1px solid #ddd;
          padding: 14px 10px;
          background: #fafbff;
        }
      }
    }
  }

.content-action {
  padding: 30px 20px;

  /deep/ .van-cell {
    margin: 6px 0px;
    border: 1px solid #ddd;
    border-radius: 10px;
  }

  .item {
    margin: 14px 0px;

    p {
      font-size: 15px;
      margin: 10px;
    }

    ul {
      display: flex;
      flex-wrap: wrap;

      li {
        margin: 0px 4px;
        width: 78px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        font-size: 14px;
        background: #f5f8fa;
        margin-bottom: 10px;
      }
    }
  }
}
  </style>
  